{
    "base": {
        "categories": {
            "Station": {
                "PointSymbolizer": {
                    "stationSymbolizer": {
                        "PointSymbolizer": {
                            "size": 1,
                            "marker": "./assets/stationFloorMarker.png",
                            "surveyMarker": "./assets/surveyed.png",
                            "currentMarker": "./assets/station-at-location.png",
                            "surveyedCurrentMarker": "./assets/surveyed-at-location.png",
                            "billboard": true,
                            "autoScale": false,
                            "color": [1.0, 1.0, 1.0, 1.0]
                        }
                    },
                    "floorSymbolizer": {
                        "PointSymbolizer": {
                            "marker": "./assets/targetMarker.svg",
                            "billboard": false,
                            "autoScale": false,
                            "size": 2,
                            "color": [0.0, 1.0, 0.0, 1.0]
                        }
                    },
                    "showLabels": true,
                    "showDecorator": true,
                    "color": [1.0, 1.0, 1.0, 1.0],
                    "labelId": "occupationPoint",
                    "selectionColor": [1.0, 1.0, 0.0, 1.0],
                    "targetDecorator": {
                        "LineSymbolizer": {
                            "strokeColor": [0, 255, 0, 1.0],
                            "strokeWidth": 4
                        }
                    }
                }
            },
            "Target": {
                "PointSymbolizer": {
                    "floorSymbolizer": {
                        "PointSymbolizer": {
                            "marker": "./assets/targetMarker.svg",
                            "selectionMarker": "./assets/targetMarker.svg",
                            "billboard": true,
                            "autoScale": false,
                            "size": 1.5,
                            "color": [1.0, 0.0, 0.0, 1.0]
                        }
                    },
                    "showLabels": true,
                    "color": [1.0, 1.0, 1.0, 1.0],
                    "labelField": "name",
                    "selectionColor": [1.0, 1.0, 0.0, 1.0]
                }
            }
        }
    },

    "collage": {
        "extends": "base"
    },

    "verity": {
        "extends": "base"
    },

    "cr": {
        "extends": "base",
        "categories": {
            "Target": {
                "PointSymbolizer": {
                    "floorSymbolizer": {
                        "PointSymbolizer": {
                            "size": 0.75
                        }
                    }
                }
            }
        },
        "overwriteSymbologies": [
            {
                "id": "pointcloudFixedColor",
                "layerType": "PointCloud",
                "PointCloudSymbolizer": {
                    "drawingRule": "POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR"
                }
            },
            {
                "id": "controlPointColor",
                "layerType": "VectorLayer",
                "category": "Control point",
                "Symbolizer": {
                    "RuleSymbolizer": {
                        "version": 1,
                        "rules": [
                            {
                                "expression": {
                                    "logicOp": "|",
                                    "rightExp": {
                                        "aritmOp": "=",
                                        "rightExp": { "constant": -2 },
                                        "leftExp": { "field": "Id" }
                                    },
                                    "leftExp": {
                                        "aritmOp": "=",
                                        "rightExp": { "constant": -2 },
                                        "leftExp": { "field": "Id" }
                                    }
                                },
                                "PointSymbolizer": {
                                    "color": [78, 236, 91, 1],
                                    "size": 15,
                                    "showLabels": true
                                },
                                "id": "greenPoints"
                            },
                            {
                                "expression": { "constant": true },
                                "PointSymbolizer": {
                                    "color": [238, 0, 4, 1],
                                    "size": 15,
                                    "showLabels": true
                                },
                                "id": "ruleGroup1"
                            }
                        ]
                    }
                }
            },
            {
                "id": "controlPointResection",
                "layerType": "VectorLayer",
                "category": "Control point",
                "Symbolizer": {
                    "RuleSymbolizer": {
                        "version": 1,
                        "rules": [
                            {
                                "expression": {
                                    "aritmOp": "IN",
                                    "rightExp": { "constant": "-2" },
                                    "leftExp": { "field": "Id" }
                                },
                                "PointSymbolizer": {
                                    "color": [78, 236, 91, 1],
                                    "size": 15,
                                    "showLabels": true
                                },
                                "id": "greenPoints"
                            },
                            {
                                "expression": { "constant": true },
                                "PointSymbolizer": {
                                    "color": [238, 0, 4, 1],
                                    "size": 15,
                                    "showLabels": true
                                },
                                "id": "ruleGroup1"
                            }
                        ]
                    }
                }
            },
            {
                "id": "pointcloudRedColor",
                "layerType": "PointCloud",
                "PointCloudSymbolizer": {
                    "drawingRule": "POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR",
                    "fixedColor": "#ff0000"
                }
            },
            {
                "id": "pointcloudBlueColor",
                "layerType": "PointCloud",
                "PointCloudSymbolizer": {
                    "drawingRule": "POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR",
                    "fixedColor": "#0000ff"
                }
            },
            {
                "id": "pointcloudTransparency",
                "layerType": "PointCloud",
                "PointCloudSymbolizer": {
                    "alpha": 0.5
                }
            }
        ]
    }
}
